<template>
    <div class="index">
        <headers :headIndex="1"></headers>
        <top-img></top-img>
        <div class="survey">
            <div class="survey-content">
                <!-- 头部导航栏 -->
                <div class="top-nav">
                    <div class="nav-item" v-for="(item, index) in navList" :key="index"
                     @click="changNav(index, $event)" :class="navIndex == index ? 'nav-item-check' : ''">{{item}}</div>
                    <div class="top-nav-line" :style="{left: left+'px'}"></div>
                </div>

                <!-- 内容 介绍-->
                <div class="survey-neir" v-show="navIndex == 0">
                    <div class="survey-neir-left">
                        <div class="survey-neir-left-title">
                            <span>COLLEGE</span>
                            <span class="survey-neir-left-title-name">书画学院简介</span>
                        </div>
                        <p class="survey-p">经深圳市政府批准，深圳市教育局注册，深圳书画艺术学院成立于1987年，是深圳市第一家专业书画艺术院校。建院近三十年来，集专业教育、素质提高、职业培训为一体，坚持弘扬中国传统文化，提升中华文化素养，繁荣鹏城艺术事业，培养专业书画人才。</p>
                    </div>
                    <img src="@/assets/image/survey.png" class="survey-img"/>
                </div>

                <!-- 简史 -->
                <div class="survey-history" v-show="navIndex == 1">
                    <p class="history-title">书画学院简史</p>
                    <p class="history-p">
                        深圳书画艺术学院前身是中国书画函授大学深圳分校，采用专业艺术教育学制，为特区书画爱好者提供一个系统学习、交流互助和实践创新的艺术教学环境，2000年曾与吉林艺术学院联合开设国家承认学历的专、本科班，先后培训成人艺术专业人才近四千位，被誉为特区书画艺术人才的摇篮。学院于1995年设立深圳市书画艺术学会，凭借毗领港澳的地理优势，开展艺术理论研究、学术交流、人才培训、展览竞赛等活动，为深圳、香港、澳门的文化艺术沟通搭建桥梁和纽带。学院设立成人书画院和少儿书画院，从三岁以上的孩子到花甲长者，为你提供最具权威的一站式教育平台。成人书画院开设两年制专科国画、书法课程，专业研习楷、魏、行、草、隶、篆等书体，及花鸟、山水、人物等国画技法，并提供素描和油画等西画课程学习。少儿书画院会聚了深圳少儿美术教育名师，精英荟萃、专业启蒙，学员作品在国内外各项比赛中屡获佳绩，引导众多学员走上艺术专业道路，成为特区少儿书画美术专业学习的首选。少儿课程：少儿书法、少儿国画、少儿美术、少儿素描、少儿动漫、中高考美术、少儿英语等；成人课程：成人国画、成人书法、成人油画、成人素描、摄影技巧等。
                        </p>
                </div>

                <!-- 地图 -->
                <div class="survey-map" v-show="navIndex == 2">
                    <div id="container" style="height:460px;width:1100px;"></div>
                    <div class="map-content">
                        <div class="map-content-left">
                            <span>电话：</span>
                            <p class="telephone"> {{ telephone }} </p>
                            <!-- <p>83155035</p> -->
                            <br>
                            <br>
                            <br>
                            <br>
                            <span>网站：</span>
                            <p class="website"> {{ website }} </p>
                        </div>

                        <div class="map-content-right">
                            <div class="right-item">
                                <svg t="1639385814339" style="width: 31px; height: 35px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3631" width="24" height="24"><path d="M663.085532 941.617711c-53.915957 0-103.881952-13.942547-135.971811-37.782511-10.568706 0.591471-19.891026 0.591471-30.315446 0-32.089859 23.839965-82.040505 37.782511-136.003534 37.782511-101.642958 0-175.465291-45.553499-175.465291-108.246353 0-30.459732 17.924231-57.833173 50.062186-77.387531-0.511653-0.799202-1.006933-1.518586-1.471514-2.270716-18.803251 13.766538-39.669488 17.668405-58.856479 11.208273-57.257052-19.426445-60.375066-119.454626-34.264385-203.637933 14.007015-44.99375 39.797401-80.281441 61.350277-103.705943-0.272199-3.021823-0.367367-6.011924-0.367367-8.985652 0-24.335245 6.347568-48.095391 18.819624-70.63985 0-0.287549 0-0.671289 0-1.006933 0-162.386414 130.807185-294.552549 291.578822-294.552549 160.755264 0 291.514353 132.166135 291.514353 294.552549 0 0.079818 0 0.207731 0 0.303922 12.774955 22.705118 19.218714 46.671972 19.218714 71.343885 0 3.309372-0.096191 6.460132-0.352017 9.689686 21.249977 23.296589 46.768163 58.31208 60.647265 102.970186 26.142403 84.21503 23.024389 184.243211-34.297131 203.669656-19.155269 6.507204-39.892569 2.558265-58.648748-11.08036-0.528026 0.751107-0.991584 1.518586-1.518586 2.222621 31.994692 19.650549 49.869804 46.880727 49.869804 77.307713C838.615291 896.064212 764.792958 941.617711 663.085532 941.617711L663.085532 941.617711zM534.005688 860.409155c5.164626 0 10.153244 1.838881 14.054087 5.196349 23.61586 20.386306 67.682495 33.033347 115.025757 33.033347 73.102948 0 132.549875-29.244045 132.549875-65.267493 0-19.042705-17.204847-37.174668-47.199998-49.694819-6.204305-2.558265-10.856255-7.930623-12.503778-14.390755-1.727341-6.507204-0.272199-13.430894 3.837398-18.675338 10.121522-12.887518 19.075451-26.654057 26.670429-40.96397 3.405563-6.299473 9.657964-10.585079 16.724917-11.288091 7.30743-0.799202 14.182001 2.046612 18.771529 7.594979 8.394181 9.993608 21.825075 22.160719 33.241079 18.291598 21.921265-7.498788 29.996175-76.172867 6.955412-150.234653-12.902868-41.636283-38.373982-73.709769-57.497529-93.26515-4.797259-4.877077-6.987135-11.751648-5.835915-18.547425 0.783853-4.749164 1.134847-9.16166 1.134847-13.606903 0-18.675338-5.452175-37.063127-16.244986-54.650691-2.286066-3.725858-3.437286-8.138354-3.118014-12.583596 0.096191-1.518586 0.144286-2.89391 0.144286-4.41352 0-138.754181-111.476931-251.573689-248.535493-251.573689-137.074935 0-248.599961 112.819508-248.599961 251.573689 0 1.6465 0.11154 3.325745 0.207731 4.9088 0.303922 4.460592-0.735757 8.857738-3.086291 12.679787-10.568706 17.412578-15.941064 35.591613-15.941064 54.05922 0 4.237511 0.367367 8.601912 1.103124 13.143345 1.039679 6.715959-1.151219 13.558807-5.900384 18.371416-19.314904 19.730367-45.105291 52.012607-58.120722 93.904717-22.976294 74.061786-14.902408 142.734842 7.03523 150.153812 11.592013 4.076852 24.943089-8.314363 33.385365-18.419512 4.573155-5.452175 11.512195-8.362458 18.755156-7.563256 7.066953 0.719384 13.399171 5.004991 16.724917 11.288091 7.563256 14.326287 16.500812 28.092825 26.670429 41.012066 4.124947 5.324262 5.531993 12.263301 3.805676 18.723434-1.679245 6.507204-6.315846 11.83249-12.503778 14.358009-30.124088 12.503778-47.40773 30.667463-47.40773 49.806359 0 36.023448 59.431577 65.267493 132.48643 65.267493 47.40773 0 91.474364-12.647041 115.121947-33.033347 4.285606-3.725858 9.737782-5.659907 15.669888-5.148253 14.437827 1.119497 26.01449 1.119497 40.85243 0C532.949636 860.409155 533.477662 860.409155 534.005688 860.409155L534.005688 860.409155z" p-id="3632"></path></svg>
                                <div class="right-item-line"></div>
                                <p>{{ qqnumber }} </p>
                            </div>
                            <div class="right-item">
                                <svg t="1639385999217" style="width: 31px; height: 35px;" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4472" width="24" height="24"><path d="M874.666667 181.333333H149.333333c-40.533333 0-74.666667 34.133333-74.666666 74.666667v512c0 40.533333 34.133333 74.666667 74.666666 74.666667h725.333334c40.533333 0 74.666667-34.133333 74.666666-74.666667V256c0-40.533333-34.133333-74.666667-74.666666-74.666667z m-725.333334 64h725.333334c6.4 0 10.666667 4.266667 10.666666 10.666667v25.6L512 516.266667l-373.333333-234.666667V256c0-6.4 4.266667-10.666667 10.666666-10.666667z m725.333334 533.333334H149.333333c-6.4 0-10.666667-4.266667-10.666666-10.666667V356.266667l356.266666 224c4.266667 4.266667 10.666667 4.266667 17.066667 4.266666s12.8-2.133333 17.066667-4.266666l356.266666-224V768c0 6.4-4.266667 10.666667-10.666666 10.666667z" p-id="4473"></path></svg>
                                <div class="right-item-line"></div>
                                <p>{{ email }}</p>
                            </div>
                            <div class="right-item">
                                <svg t="1639386046329" style="width: 31px; height: 35px;" class="icon" viewBox="0 0 1025 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5987" width="24" height="24"><path d="M365.062518 704 217.862518 704C198.662518 704 173.062518 716.8 166.662518 729.6L6.662517 934.4C-6.137483 947.2 0.262517 960 19.462517 960L1005.062515 960C1024.262515 960 1030.662515 947.2 1017.862515 934.4L857.862515 729.6C845.062515 716.8 825.862515 704 806.662515 704L659.462515 704 608.262518 768 806.662515 768 909.062515 896 115.462518 896 217.862518 768 416.262518 768 365.062518 704 365.062518 704 365.062518 704 365.062518 704Z" p-id="5988"></path><path d="M512.0032 64C371.2032 64 256.0032 179.2 256.0032 320 256.0032 364.8 268.8032 409.6 288.0032 448L448.0032 723.2C486.4032 787.2 544.0032 787.2 576.0032 723.2L723.2032 460.8C748.8032 422.4 768.0032 371.2 768.0032 320 768.0032 179.2 652.8032 64 512.0032 64L512.0032 64ZM672.0032 416 544.0032 646.4C518.4032 691.2 505.6032 691.2 480.0032 646.4L345.6032 409.6C326.4032 384 320.0032 352 320.0032 313.6 320.0032 211.2 403.2032 128 512.0032 128 620.8032 128 704.0032 211.2 704.0032 313.6 704.0032 352 691.2032 384 672.0032 416L672.0032 416Z" p-id="5989"></path></svg>
                                <div class="right-item-line"></div>
                                <div>
                                    <div>{{ address }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footers></footers>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from '@/components/headers'
import footers from '@/components/footers'
import topImg from '@/components/topImg'
import { lazyAMapApiLoaderInstance } from 'vue-amap'
import MapLoader from '@/plugins/amap.js'
export default {
    name: 'survey',
    components:{
        headers,
        footers,
        topImg
    },
    data() {
        return {
            navList: ['学院介绍', '学院简史', '联系我们'],
            navIndex: 0,
            left: 74,
            map: null,
            name:"",//网站名称
            beian:'',//备案号
            support :'',//技术支持
            telephone:'',//电话
            website:'',//网站地址
            qqnumber:'',//QQ号
            email:'',//邮箱地址
            address:'',//学院详细地址
            notice:"",//公告通知
            jgurl:'',//机构登录跳转
            ksurl:'',//考生登录跳转地址
            logo:'',//官网LOGO
            public_code:'',//底部二维码
            keywords:'',//网站关键词
            description:'',//网址简介
            copyright:'',//网站版权所有
        }
    },
    created() {
        if(this.$route.query.index){
            this.navIndex=this.$route.query.index
            this.left = 74+(146*this.navIndex)
        }
        
        // console.log(this.left)
        // 获取数据 初次渲染
        this.$request({
            url:'/api/common/webinfo',
            method:'POST',
            data:{}
        }).then(res=>{
            if(res.code==1){
                // console.log(res)
                let data = res.data
                this.telephone= data.telephone//电话
                this.website = data.website//网址
                this.qqnumber = data.qqnumber//qq
                this.address = data.address//地址
                this.email = data.email//邮箱
            }
        })
    },
    mounted() {
        let that = this
        MapLoader().then(AMap => {
            // console.log('地图加载成功')
            that.map = new AMap.Map("container", {
                resizeEnable: true,
                zoom: 13
            });

            var marker = new AMap.Marker({
                position: new AMap.LngLat(114.08248, 22.53705),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                title: '深圳'
            });
             marker.setIcon('//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png')
            // 将创建的点标记添加到已有的地图实例：
            this.map.add(marker);

            // 创建纯文本标记
            // var text = new AMap.Text({
            //     text:'纯文本标记',
            //     anchor:'center', // 设置文本标记锚点
            //     draggable:true,
            //     cursor:'pointer',
            //     angle:10,
            //     style:{
            //         'padding': '.75rem 1.25rem',
            //         'margin-bottom': '1rem',
            //         'border-radius': '.25rem',
            //         'background-color': 'white',
            //         'width': '15rem',
            //         'border-width': 0,
            //         'box-shadow': '0 2px 6px 0 rgba(114, 124, 245, .5)',
            //         'text-align': 'center',
            //         'font-size': '20px',
            //         'color': 'blue'
            //     },
            //     position: [114.08248, 22.53705]
            // });

            // text.setMap(that.map);
        }, e => {
        console.log('地图加载失败' ,e)
        })
        
    },
    methods: {
        changNav(index, e) {
            // console.log(e)
            this.navIndex = index
            this.left = 74+(146*index)
        }
    }
}
</script>
<style lang="scss" scoped>
    .index{
        width: 100vw;
    }
    
    .survey{
        width: 100%;
        display: flex;
        justify-content: center;
        background: #F6F6EA;
    }
    .survey-content{
        width: 1200px;
        background: #ffffff;
        display: flex;
        flex-direction: column;
    }
    // 头部导航栏
    .top-nav{
        padding-top: 40px;
        padding-bottom: 23px;
        border-bottom: 1px solid #CCCCCC;
        display: flex;
        position: relative;
    }
    .top-nav-line{
        width: 49px;
        height: 2px;
        background: #26716C;
        border-radius: 1px;
        position: absolute;
        bottom: 0;
        transition: all 1s;
    }
    .nav-item{
        padding-left: 50px;
        color: #333333;
        font-size: 24px;
        cursor: pointer;
    }
    .nav-item-check{
        color: #26716C;
        font-weight: 550;
    }

    // 内容
    .survey-neir{
        display: flex;
        padding: 80px 50px;
        justify-content: space-between;
    }
    .survey-neir-left{
        display: flex;
        flex-direction: column;
        padding-right: 48px;
    }
    .survey-neir-left-title{
        color: #26716C;
        font-size: 24px;
        display: flex;
        flex-direction: column;
    }
    .survey-neir-left-title-name{
        font-weight: bold;
        font-size: 36px;
        padding-top: 6px;
    }
    .survey-p{
        text-indent: 2em;
        padding-top: 50px;
        color: #272727;
        font-size: 18px;
        line-height: 30px;
    }
    .survey-img{
        width: 459px;
        height: 326px;
    }
    // 简史
    .survey-history, .survey-map{
        display: flex;
        flex-direction: column;
        padding: 80px 50px;
    }
    .history-title{
        color: #272727;
        font-size: 30px;
        font-weight: 500;
        text-align: center;
    }
    .history-p{
        padding-top: 40px;
        color: #3D3D3D;
        font-size: 18px;
        line-height: 35px;
        text-indent: 2em;
    }

    // 地图
    .map-content{
        display: flex;
        justify-content: space-between;
        padding-top: 60px;
    }
    .map-content-left{
        flex: 1;
        display: flex;
        flex-direction: column;
        color: #313131;
    }
    .map-content-left p {
        font-weight: bold;
        font-size: 28px;
        padding-top: 16px;
    }
    .map-content-right{
        display: flex;
    }
    .right-item{
        width: 200px;
        height: 245px;
        padding: 24px;
        border: 1px solid #E4E4E4;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        align-items: center;
        position: relative;
        cursor: pointer;
    }
    .right-item-line{
        width: 16px;
        height: 3px;
        background: #26716C;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .website,.telephone{
        font-weight: 100 !important;
    }
</style>